import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV == 'production') {
  Sentry.init({
    dsn: 'https://dcfbe52a17024aef8d655dce67b83daf@sentry.io/1253507',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
  })
  const VueSentry = {
    install(Vue) {
      Vue.prototype.$sentry = Sentry;
    }
  }
  Vue.use(VueSentry)
}
